module.exports = __webpack_public_path__ + "assets/img/box1-7.f2bffc4c.svg";